import { gql } from '@apollo/client'

export const MultipartUploadSignature = gql`
    query MultipartUploadSignature($uploadId: ID!, $hash: String!, $partNumber: Int!) {
        multipartUploadSignature(uploadId: $uploadId, hash: $hash, partNumber: $partNumber)
    }
`

export default MultipartUploadSignature
